import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Regions API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const REGIONS_API_ENDPOINTS = {
  listRegions: {
    generated: 'regionsAdminControllerListRegionsV1',
    method: 'get',
    path: '/api/v1/admin/regions',
  },
  createRegion: {
    generated: 'regionsAdminControllerCreateRegionV1',
    method: 'post',
    path: '/api/v1/admin/regions',
  },
  getRegion: {
    generated: 'regionsAdminControllerGetRegionV1',
    method: 'get',
    path: '/api/v1/admin/regions/:id',
  },
  updateRegion: {
    generated: 'regionsAdminControllerUpdateRegionV1',
    method: 'put',
    path: '/api/v1/admin/regions/:id',
  },
  deleteRegion: {
    generated: 'regionsAdminControllerDeleteRegionV1',
    method: 'delete',
    path: '/api/v1/admin/regions/:id',
  },
  listRegionIps: {
    generated: 'regionIpsAdminControllerListRegionIpsV1',
    method: 'get',
    path: '/api/v1/admin/regions/:id/ips',
  },
  createRegionIp: {
    generated: 'regionIpsAdminControllerCreateRegionIpV1',
    method: 'post',
    path: '/api/v1/admin/regions/:id/ips',
  },
  updateRegionIp: {
    generated: 'regionIpsAdminControllerUpdateRegionIpV1',
    method: 'put',
    path: '/api/v1/admin/regions/:id/ips/:ipId',
  },
  deleteRegionIp: {
    generated: 'regionIpsAdminControllerDeleteRegionIpV1',
    method: 'delete',
    path: '/api/v1/admin/regions/:id/ips/:ipId',
  },
} as const satisfies Record<string, EndpointDef>;

export type RegionsEndpointName = keyof typeof REGIONS_API_ENDPOINTS;
